import queryClient from '../../../ReactQuery/client';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { remove } from '../../../redux/api';

import { rolesQueryKey } from './useRoles';

async function deleteRole(roleId: number): Promise<void> {
  await remove(`/api/roles/${roleId}`);
}

/**
 * Delete a custom role.
 */
export default function useDeleteRole() {
  return useToastedMutation({
    mutationFn: deleteRole,
    successToastMessage: 'Role deleted successfully',
    errorToastMessage: 'Failed to delete role',
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: rolesQueryKey });
    },
  });
}
